import React from "react";
import { render } from "react-dom";
import App from "./App.jsx";
import "../../styles/index.styl";
import { IntlProviderWrapper } from "./IntlContext";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: window.PROPS.SENTRY_FRONTEND_DSN,
  tracesSampleRate: 0.2,
  maxBreadcrumbs: 50,
  attachStacktrace: true,
  autoSessionTracking: true,
  debug: window.PROPS.ENV_NAME !== "production",
  environment: window.PROPS.ENV_NAME,
  enableTracing: true,
  release: window.PROPS.SENTRY_RELEASE,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.2, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

});

render(<App {...PROPS} />, document.getElementById("root"));
